// import { Message } from "element-ui";

const rolesKey = {
    1: 'super_admin',
    2: 'normal',
    'super_admin': 1,
    'normal': 2
};

/**
 * Mutual exclusion rules related -------------------------------开始
 */

const forbiddenCodeArr = [
    {
        "code": "234",
        "value": ["1"],
        "forbiddenCode": ["16", "18", "20", "220"]
    },
    {
        "code": "20",
        "value": ["1", "5", "6", "8", "14", "15", "16", "17"],
        "forbiddenCode": ["22", "24", "26"]
    },
    {
        "code": "220",
        "value": ["10"],
        "forbiddenCode": ["18", "20"]
    },
    {
        "code": "20",
        "value": ["1", "15"],
        "forbiddenCode": ["18"]
    },
    {
        "code": "248,33",
        "value": ["1"],
        "forbiddenCode": ["16", "234", "20"]
    },
];

let forbiddenCodeObj = [], temArr = [], temArr2 = [], temForbiddenCode = '';
const forbiddenConnect = {}, codeForbiddenConnect = {};
forbiddenCodeArr.forEach(i => {
    forbiddenCodeObj.push(i.code);
    i.forbiddenCode.forEach(j => {
        temForbiddenCode = ["22", "24", "26"].includes(j) ? 'colorCode' : j;

        temArr = forbiddenConnect[temForbiddenCode] || [];
        i.value.forEach(k => temArr.push(i.code + '-' + k));
        forbiddenConnect[temForbiddenCode] = temArr;

        temArr2 = codeForbiddenConnect[i.code] || [];
        !temArr2.includes(temForbiddenCode) && temArr2.push(temForbiddenCode);
        codeForbiddenConnect[i.code] = temArr2;
    })
});



const forbiddenCodeArr_set = [
    {
        "code": "20",
        "value": ["1", "5", "6", "8", "14", "15", "16", "17"],
        "forbiddenCode": ["22", "24", "26"]
    },
];

let forbiddenCodeObj_set = [], temArr_set = [], temArr2_set = [], temForbiddenCode_set = '';
const forbiddenConnect_set = {}, codeForbiddenConnect_set = {};
forbiddenCodeArr_set.forEach(i => {
    forbiddenCodeObj_set.push(i.code);
    i.forbiddenCode.forEach(j => {
        temForbiddenCode_set = ["22", "24", "26"].includes(j) ? 'colorCode' : j;

        temArr_set = forbiddenConnect_set[temForbiddenCode_set] || [];
        i.value.forEach(k => temArr_set.push(i.code + '-' + k));
        forbiddenConnect_set[temForbiddenCode_set] = temArr_set;

        temArr2_set = codeForbiddenConnect_set[i.code] || [];
        !temArr2_set.includes(temForbiddenCode_set) && temArr2_set.push(temForbiddenCode_set);
        codeForbiddenConnect_set[i.code] = temArr2_set;
    })
});




/**
*Mutual Exclusion Rules Related ---------------------------------------------------------------
*/
/**
*Special Value Selection Related ------------------------------ Start
*/

const selectedCodeArr = [
    {
        "code": "220",
        "value": ["3"],
        "selectCodeArr": ["20-15"]
    },
];

/**
*Special value selection related to ---------------------------------------------------------------
*/



/**
 * 
ScenarioMode string<byte>Scene modes: 0 initial settings, 1 image production, 2 digital cinema, 3 video creation
ColorGamut string<byte>Color temperature Color gamut: 0 sRGB, 1 warm color temperature, 2 standard color temperature, 3 cool color temperature, 4 customized 1
VideoSignal input signal: 0 HDM1,  1 DP1,  2 USB-C1
GameMode: 0 levels, 1 FPS1, 2 FPS2 ,  3 RCG ,  4 RTS, 5 Games 1
hdr HDR: 0 closed, 1 automatic, 2 HDR400,  HDR games, HDR movies, HDR photos
AspectRatio display ratio: 0 full screen, 1 original ratio
DynamicContrast: 0 off, 1 on
Response Time: 0 off, 1 normal, 2 rapid
SmartEnergy: 0 off, 1 on
SmartTrafficLight intelligent traffic light: 0 off, 1 automatic, 2 on
SmartAudio: 0 off, 1 on
FaceTracking: 0 off, 1 on
AutoAlarm automatic warning: 0 off, 1 on
WakeonTouch touch wake-up: 0 off, 1 on
DaisyChain daisy chain: 0 off, 1 automatic, 2 on
vpro vPro: 0 closed, 1 open


ekvm eKVM:o off ,  1. Use keyboard, 2. Use mouse
TrueSplit hard split screen: 0 off, 1 on
LanIndicator LAN indicator light: 0 not connected, 1 0Mbps ,  970Mbps
AudioSmartSwitch: 0 off, 1 on
Overclock overclocking: 0 off, 1 on
Gamma value: 1 1.0,  2 1.8,  3 2.0,  4 2.2,  5 2.4 ,  6 2.6,  7 3.0
Color adjustment: rgb , Separate with commas, for example, 23, 98, 34 represent, red23，green98，blue34
Sitting reminder: 0 off, 1 on
DistanceWarning distance detection: 0 off, 1 on
AmbientLightDetection: 0 off, 1 on
SmartPower USB-C Charging: 0 Automatic, 1 Off
pipPbp PiP/PbP:  0 closed, 1 picture in picture, 2 side drawing
KVM Switch: 0 off, 1 on
DpSelect DP mode: 0 DP1.2,  1 DP1.4
USBSelect USB mode: 0 USB2.0, 1 USB3.0
USB charging: 0 off, 1 on
 */
const monitorTableColumns = [
    { name: 'Group', key: 'groupName', className: 'columns-w80' },
    { name: 'Monitor Model', key: 'modelname', className: 'columns-w160' },
    { name: "Special ID", key: 'specialId', className: 'columns-w130' },
    { name: 'Host Name', key: 'computerName', className: 'columns-w200' },
    { name: 'Serial No', key: 'sn', className: 'columns-w200' },
    { name: 'Firmware Version', key: 'version', className: 'columns-w160' },
    { name: 'Host Status', key: 'onlineStatusStr', className: 'columns-w130' },
    { name: 'Monitor Status', key: 'powerStatusStr', className: 'columns-w140' },
    { name: 'Update Progress', key: 'upgradeProgress', className: 'columns-w270' },
    { name: 'Settings Profile', key: 'settingName', className: 'columns-w140' },
    { name: 'Tips', key: 'tip', className: 'columns-w100' },
    { name: 'Active Time', key: 'useTimes', className: 'columns-w160' }, 
    { name: 'Brightness', key: 'brightness', className: 'columns-w120' },
    { name: 'Contrast', key: 'contrast', className: 'columns-w140' }, 
    { name: 'Scenario Mode', key: 'scenarioModeStr', className: 'columns-w160' },
    { name: 'Color Gamut & Color Temperature', key: 'colorGamutStr', className: 'columns-w270' }, 
    { name: 'Video Signal', key: 'videoSignalStr', className: 'columns-w140' },
    { name: 'Aspect Ratio', key: 'aspectRatioStr', className: 'columns-w140' },
    { name: 'Dynamic Contrast', key: 'dynamicContrastStr', className: 'columns-w180' },
    { name: 'Response Time', key: 'responseTimeStr', className: 'columns-w160' },
    { name: 'Smart Energy', key: 'smartEnergyStr', className: 'columns-w160' },
    { name: 'Smart Traffic Light', key: 'smartTrafficLightStr', className: 'columns-w180' }, 
    { name: 'Smart Audio', key: 'smartAudioStr', className: 'columns-w140' },
    { name: 'Face Tracking', key: 'faceTrackingStr', className: 'columns-w160' }, 
    { name: 'Auto-alarm', key: 'autoAlarmStr', className: 'columns-w140' },
    { name: 'Waken on Touch', key: 'wakenonTouchStr', className: 'columns-w160' }, 
    { name: 'daisy chain', key: 'daisyChainStr', className: 'columns-w160' },
    { name: 'vPro', key: 'vproStr', className: 'columns-w120' }, 
    { name: 'Smart Light', key: 'smartLight', className: 'columns-w140' },
    { name: 'eKVM', key: 'ekvmStr', className: 'columns-w120' }, 
    { name: 'True Split', key: 'trueSplitStr', className: 'columns-w140' },
    { name: 'Lan Indicator', key: 'lanIndicatorStr', className: 'columns-w160' }, 
    { name: 'Audio Smart Switch', key: 'audioSmartSwitchStr', className: 'columns-w180' },
    { name: 'Overclock', key: 'overclockStr', className: 'columns-w120' }, 
    { name: 'Game Mode', key: 'gameModeStr', className: 'columns-w120' },
    { name: 'Gamma', key: 'gamma', className: 'columns-w120' }, 
    { name: 'RGB Gain', key: 'colorTuning', className: 'columns-w140' },
    { name: 'Sitting Reminder', key: 'sittingReminderStr', className: 'columns-w160' }, 
    { name: 'Distance Warning', key: 'distanceWarningStr', className: 'columns-w180' },
    { name: 'Ambient Light Detection', key: 'ambientLightDetectionStr', className: 'columns-w220' }, 
    { name: 'HDR', key: 'hdrStr', className: 'columns-w120' },
    { name: 'USB-C Charging', key: 'smartPowerStr', className: 'columns-w150' }, 
    { name: 'PiP/PbP', key: 'pipPbpStr', className: 'columns-w140' },
    { name: 'KVM Switch', key: 'kvmSwitchStr', className: 'columns-w140' }, 
    { name: 'DP Select', key: 'dpSelectStr', className: 'columns-w120' },
    { name: 'USB Select', key: 'usbSelectStr', className: 'columns-w120' }, 
    { name: 'USB Charging', key: 'usbChargeStr', className: 'columns-w150' },
    { name: 'Volume Control', key: 'volumeControl', className: 'columns-w160' }
];

const tranKey = `onlineStatusStr,powerStatusStr,lockStatusStr,tip,upgradeProgress,scenarioModeStr,videoSignalStr,colorGamutStr,aspectRatioStr,dynamicContrastStr,responseTimeStr,smartEnergyStr,smartTrafficLightStr,daisyChainStr,ekvmStr,gameModeStr,smartAudioStr,faceTrackingStr,autoAlarmStr,wakenonTouchStr,trueSplitStr,lanIndicatorStr,audioSmartSwitchStr,overclockStr,sittingReminderStr,distanceWarningStr,ambientLightDetectionStr,hdrStr,smartPowerStr,pipPbpStr,kvmSwitchStr,dpSelectStr,usbSelectStr,usbChargeStr`;

const monitorTableOperaBtns = [
    [
        {
            name: 'New Group',
            type: 'create',
            roles: ['super_admin'],
        },
        {
            name: 'Delete Group',
            title: 'Select an item and then delete',
            type: 'delete',
            roles: ['super_admin'],
        },
        {
            name: 'Move To',
            expand: true,
            roles: ['super_admin']
        },
        {
            name: 'Collapse',
            type: 'coalless',
            roles: ['super_admin', 'normal'],
        },
        {
            name: 'Expand',
            type: 'expand',
            roles: ['super_admin', 'normal']
        },
        {
            name: 'Display Columns',
            type: 'display',
            roles: ['super_admin', 'normal']
        },

    ],
    [
        {
            name: 'Power On',
            type: 'open',
            roles: ['super_admin']
        },
        {
            name: 'Power Off',
            type: 'close',
            roles: ['super_admin']
        },

        {
            name: 'Restore Factory Settings',
            type: 'restore',
            roles: ['super_admin']
        }
    ],
    [
        {
            name: 'Settings',
            type: 'setting',
            roles: ['super_admin']
        },
        {
            name: 'Export Settings Profiles',
            type: 'exportSetting',
            roles: ['super_admin']
        },
        {
            name: 'Export',
            type: 'export',
            roles: ['super_admin']
        },
        {
            name: 'Update',
            type: 'upgrade',
            roles: ['super_admin']
        }
    ],
    [
        {
            name: 'Delete Monitor',
            type: 'deleteDisplay',
            roles: ['super_admin']
        }
    ]
];

const languageArr = [
    {
        name: '阿拉伯语',
        languageKey: 'ar',
        keyS: 'ar',
        keyB: ['SA', 'EG'],
        keyA: ['ar-SA', 'ar-EG'],
    },
    {
        name: '保加利亚语',
        languageKey: 'bgBg',
        keyS: 'bg',
        keyB: ['BG'],
        keyA: ['bg-BG'],
    },
    {
        name: '捷克语',
        languageKey: 'csCz',
        keyS: 'cs',
        keyB: ['CZ'],
        keyA: ['cs-CZ'],
    },
    {
        name: '丹麦语',
        languageKey: 'daDk',
        keyS: 'da',
        keyB: ['DK'],
        keyA: ['da-DK'],
    },
    {
        name: '德语',
        languageKey: 'de',
        keyS: 'de',
        keyB: ['DE', 'AT'],
        keyA: ['de-DE', 'de-AT'],
    },
    {
        name: '希腊语',
        languageKey: 'elGr',
        keyS: 'el',
        keyB: ['GR'],
        keyA: ['el-GR'],
    },
    {
        name: '英语',
        languageKey: 'en',
        keyS: 'en',
        keyB: ['US', 'GB'],
        keyA: ['en-US', 'en-GB'],
    },
    {
        name: '西班牙语',
        languageKey: 'es',
        keyS: 'es',
        keyB: ['ES'],
        keyA: ['es-ES', 'es-MX'],
    },
    {
        name: '芬兰语',
        languageKey: 'fiFi',
        keyS: 'fi',
        keyB: ['Fi'],
        keyA: ['fi-Fi'],
    },
    {
        name: '法语',
        languageKey: 'fr',
        keyS: 'fr',
        keyB: ['FR', 'CA'],
        keyA: ['fr-FR', 'fr-CA'],
    },
    {
        name: '克罗地亚语',
        languageKey: 'hr',
        keyS: 'hr',
        keyB: ['HR'],
        keyA: ['hr-HR'],
    },
    {
        name: '匈牙利语',
        languageKey: 'huHu',
        keyS: 'hu',
        keyB: ['HU'],
        keyA: ['hu-HU'],
    },
    {
        name: '印尼语',
        languageKey: 'inId',
        keyS: 'id',
        keyB: ['ID'],
        keyA: ['id-ID'],
    },
    {
        name: '意大利语',
        languageKey: 'it',
        keyS: 'it',
        keyB: ['IT'],
        keyA: ['it-IT'],
    },
    {
        name: '希伯来语',
        languageKey: 'iwIl',
        keyS: 'he',
        keyB: ['IL'],
        keyA: ['he-IL'],
    },
    {
        name: '日本语',
        languageKey: 'ja',
        keyS: 'ja',
        keyB: ['JP'],
        keyA: ['ja-JP'],
    },
    {
        name: '韩语',
        languageKey: 'ko',
        keyS: 'ko',
        keyB: ['KR'],
        keyA: ['ko-KR'],
    },
    {
        name: '挪威语',
        languageKey: 'nb',
        keyS: 'nb',
        keyB: ['NB', 'NO'],
        keyA: ['nb-NB', 'no-NO'], // NO is prohibited from use.
    },
    {
        name: '荷兰语',
        languageKey: 'nl',
        keyS: 'nl',
        keyB: ['NL', 'NE'],
        keyA: ['nl-NL', 'nl-NE'],
    },
    {
        name: '波兰语',
        languageKey: 'plPl',
        keyS: 'pl',
        keyB: ['PL'],
        keyA: ['pl-PL'],
    },
    {
        name: '巴西葡萄牙语',
        languageKey: 'ptBr',
        keyS: 'pt',
        keyB: ['BR'],
        keyA: ['pt-BR'],
    },
    {
        name: '葡萄牙葡萄牙语',
        languageKey: 'ptPt',
        keyS: 'pt',
        keyB: ['PT'],
        keyA: ['pt-PT'],
    },
    {
        name: '罗马尼亚语',
        languageKey: 'roRo',
        keyS: 'ro',
        keyB: ['RO'],
        keyA: ['ro-RO'],
    },
    {
        name: '俄语',
        languageKey: 'ruRu',
        keyS: 'ru',
        keyB: ['RU'],
        keyA: ['ru-RU'],
    },
    {
        name: '斯洛伐克语',
        languageKey: 'skSk',
        keyS: 'sk',
        keyB: ['SK'],
        keyA: ['sk-SK'],
    },
    {
        name: '斯洛文尼亚语',
        languageKey: 'slSi',
        keyS: 'sl',
        keyB: ['SI'],
        keyA: ['sl-SI'],
    },
    {
        name: '塞尔维语言',
        languageKey: 'sr',
        keyS: 'sr',
        keyB: ['RS', 'ME', 'BA'],
        keyA: ['sr-RS', 'sr-ME', 'sr-BA'],
    },
    {
        name: '瑞典语',
        languageKey: 'sv',
        keyS: 'sv',
        keyB: ['SE'],
        keyA: ['sv-SE'],
    },
    {
        name: '泰语',
        languageKey: 'th',
        keyS: 'th',
        keyB: ['TH'],
        keyA: ['th-TH'],
    },
    {
        name: '土耳其语',
        languageKey: 'trTr',
        keyS: 'tr',
        keyB: ['TR'],
        keyA: ['tr-TR'],
    },
    {
        name: '乌克兰语',
        languageKey: 'ukUa',
        keyS: 'uk',
        keyB: ['UA'],
        keyA: ['uk-UA'],
    },
    {
        name: '中文',
        languageKey: 'zh',
        keyS: 'zh',
        keyB: ['CN'],
        keyA: ['zh-CN'],
    },
    {
        name: '繁体中文',
        languageKey: 'zhHant',
        keyS: 'zh',
        keyB: ['TW', 'HK'],
        keyA: ['zh-TW', 'zh-HK'],
    },
];

let languageKeyObj = {};
languageArr.forEach(i => {
    if(languageKeyObj[i.keyS]) {
        languageKeyObj[i.keyS] = languageKeyObj[i.keyS].length ? [...languageKeyObj[i.keyS], i] : [languageKeyObj[i.keyS], i];
    } else {
        languageKeyObj[i.keyS] = i;
    }
});

const detectBrowserLanguage = () => {
    const language = window.navigator.languages ? window.navigator.languages[0] : window.navigator.userLanguage || window.navigator.language;
    let finalLanguage = language.toLowerCase().split('-')[0], temLanguageObj = null;
    
    /* two language need to noted below code */
    /*
    if(!languageKeyObj[finalLanguage] || !finalLanguage) {
        finalLanguage = 'en'; // Unable to find language. Default language used is English
    }
    
    if(!['zh', 'en'].includes(finalLanguage)) { // The translation file does not exist and defaults to English
        finalLanguage = 'en';
    }
    
    if(languageKeyObj[finalLanguage].length && languageKeyObj[finalLanguage].length > 0) {
        temLanguageObj = languageKeyObj[finalLanguage].filter(i => i.keyA.includes(language))[0];
    } else {
        temLanguageObj = languageKeyObj[finalLanguage]
    }
    */
    /* end */

    ////finalLanguage = temLanguageObj ? temLanguageObj.languageKey : 'en'; // this code : when browser language is zh that the finalLanguage modify en

    /* mult language use this code fix ru and uk bug */
    
    if(finalLanguage == "ru")
    {
        finalLanguage = "ruRu";
    }
    else if(finalLanguage == "uk")
    {
        finalLanguage = "ukUa";
    }
    if(language == "zh-TW")
    {
        finalLanguage = "zhHant";
    }

    if(!window.langs){
        if(finalLanguage!='en'&&finalLanguage!='zh'){
            finalLanguage='en'
        }
    }
    
    /* end */

    return finalLanguage;
}

const codeTypeEnum = {
    'radiogroup-img': '',
    'radiogroup': '',
    'slider-stop': '',
    'slider-list-color': '',
    'slider': '',
    'tabs': '',
    'switch': '',
};

const userLanguage = detectBrowserLanguage();

window.userLanguage = userLanguage;

/**
 * Verify password format
 * @param {*} password 
 * @returns 
 */
function isValidPassword(password) {
    // Define regular expressions for checking each type of character  
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[^A-Za-z0-9]/.test(password); // Exclude any characters of letters and numbers
    // Check if there are at least three types included
    const typesCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;

    return typesCount >= 3;
}
/**
 * Verify username format
 * @param {*} username 
 * @returns 
 */
function isValidUsername(username) {
    // Define regular expressions for checking each type of character  
    const hasUpperCase = /[A-Z]/.test(username);
    const hasLowerCase = /[a-z]/.test(username);
    const hasNumber = /\d/.test(username);
    // Check if there are at least three types included
    const typesCount = [hasUpperCase, hasLowerCase, hasNumber].filter(Boolean).length;

    return typesCount >= 2;
}

const regexPatternsObj = {
    'zh-cn': /[\u4e00-\u9fff]/,
    'en': /[a-zA-Z]/,
    'zh-tw': /[\u4e00-\u9fff]/,
    'fr': /[éèêëàâäôöûüç]/,
    'de': /[äöüß]/,
    'it': /[àèéìòù]/,
    'ja': /[\u3040-\u30ff\u31f0-\u31ff]/,
    'es': /[áéíñóúü]/,
    'ko': /[\uac00-\ud7af]/,
    'th': /[\u0e00-\u0e7f]/,
    'ru': /[\u0400-\u04ff]/,
    'tr': /[çğıöşü]/,
    'pl': /[ąćęłńóśźż]/,
    'cs': /[čďěňřšťůž]/,
    'hu': /[áéíóöőúüű]/,
    'uk': /[\u0400-\u04ff]/,
    'ar': /[\u0600-\u06ff]/,
    'id': /[a-zA-Z]/,
    'pt-br': /[ãõáéíóúç]/,
    'bg': /[\u0400-\u04ff]/,
    'hr': /[čćđšž]/,
    'da': /[æøå]/,
    'nl': /[a-zA-Z]/,
    'fi': /[äö]/,
    'el': /[\u0370-\u03ff]/,
    'he': /[\u0590-\u05ff]/,
    'no': /[æøå]/,
    'ro': /[ăâîșț]/,
    'sr': /[čćđšž]/,
    'sk': /[áäčďéíĺľňóôŕšťúýž]/,
    'sl': /[čšž]/,
    'sv': /[åäö]/
};
const regexPatterns = /^[ \u3000-\u303F\uFF00-\uFFEF!-\/:-@\[-`{-~0-9\u4e00-\u9fffa-zA-Z\u4e00-\u9ffféèêëàâäôöûüçäöüßàèéìòù\u3040-\u30ff\u31f0-\u31ffáéíñóúü\uac00-\ud7af\u0e00-\u0e7f\u0400-\u04ffçğıöşüąćęłńóśźżčďěňřšťůžáéíóöőúüű\u0400-\u04ff\u0600-\u06ffãõáéíóúç\u0400-\u04ffčćđšžæøåäö\u0370-\u03ff\u0590-\u05ffæøåăâîșțčćđšžáäčďéíĺľňóôŕšťúýžčšžåäö]+$/;
const textAreaPatterns = /^[ \u3000-\u303F\uFF00-\uFFEF!-\/:-@\[-`\n\r{-~0-9\u4e00-\u9fffa-zA-Z\u4e00-\u9ffféèêëàâäôöûüçäöüßàèéìòù\u3040-\u30ff\u31f0-\u31ffáéíñóúü\uac00-\ud7af\u0e00-\u0e7f\u0400-\u04ffçğıöşüąćęłńóśźżčďěňřšťůžáéíóöőúüű\u0400-\u04ff\u0600-\u06ffãõáéíóúç\u0400-\u04ffčćđšžæøåäö\u0370-\u03ff\u0590-\u05ffæøåăâîșțčćđšžáäčďéíĺľňóôŕšťúýžčšžåäö]+$/;
const noSymbolRegexPatterns = /^[0-9\u4e00-\u9fffa-zA-Z\u4e00-\u9ffféèêëàâäôöûüçäöüßàèéìòù\u3040-\u30ff\u31f0-\u31ffáéíñóúü\uac00-\ud7af\u0e00-\u0e7f\u0400-\u04ffçğıöşüąćęłńóśźżčďěňřšťůžáéíóöőúüű\u0400-\u04ff\u0600-\u06ffãõáéíóúç\u0400-\u04ffčćđšžæøåäö\u0370-\u03ff\u0590-\u05ffæøåăâîșțčćđšžáäčďéíĺľňóôŕšťúýžčšžåäö]+$/;

/**
 * Obtain an absolutely unique ID string
 * @return {string}
 */
function generateId() {
    return 'id-' + Math.random().toString(36).slice(2, 9) + Date.now();
}

/**
 * 获取encrypt后的Key
 * @param {*} password 
 * @param {*} publicKey 
 * @return {*}
 */
// Create JSEncrypt instance
const encrypt = new JSEncrypt();

function getEncryptKey(password, publicKey) { // Set Public Key
    encrypt.setPublicKey(publicKey);

    return encrypt.encrypt(password);
}

/**
 * Return unique key
 * @return {String}
 */
let key = 0;
function getKey() {
    return Date.now() + (key++).toString();
}

/**
*Uuid object
*Store the regionLock value of the currently locked element
*/
const uuid = {
    uuid: "",
    uuidList: [],
    curIndex: -1,
    lastActiveElement: {}, // Last time we focused on the elements, it's convenient to return them to their original positions
    getId: () => {
        return this.uuidList.slice(-1);
    },
    setId: (temUuid) => {
        return (this.uuid = temUuid);
    },
    /**
     * Focus on the current area
     * @param {String} regionLockId Area ID of the focused area
     * @param {Function} vueNextTick Vue's NextTick method
     * Abandoned parameters @param {Element} regionLockAreaEl Area elements controlled by v-show display in the focused area
     */
    intoLockArea(regionLockId, vueNextTick) {
        this.uuid = regionLockId;
        this.uuidList.push(regionLockId);
        this.lastActiveElement[regionLockId] = document.activeElement;
        vueNextTick(() => {
            let eleList = getFocusableElements(document.querySelector(`[regionLock="${regionLockId}"]`)) || [];
            eleList[0] && eleList[0].focus && eleList[0].focus();
        });
    },
    /**
     * Exit the current focus area
     * @param {*} regionLockId 
     */
    exitLockArea(regionLockId) {
        this.uuidList = this.uuidList.slice(0, -1);
        this.lastActiveElement[regionLockId] && this.lastActiveElement[regionLockId].focus && this.lastActiveElement[regionLockId].focus();
        this.uuid = this.uuidList.slice(-1) || '';
    }
};

/**
 * Get a list of focused elements under a certain element
 * @param {Element} container Query container elements
 * @returns {Elements} Focused Element List
 */
function getFocusableElements(container) {
    // Define a selector for focusing elements
    const focusableSelector = [
      'a[href]:not([tabindex="-1"])',
      'button:not([disabled]):not([tabindex="-1"])',
      'input:not([type="hidden"]):not([disabled]):not([tabindex="-1"])',
      'select:not([disabled]):not([tabindex="-1"])',
      'textarea:not([disabled]):not([tabindex="-1"])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
  
    // Find all matching elements
    const focusableElements = container.querySelectorAll(focusableSelector);
  
    // Filter out truly focused elements
    const filteredElements = Array.from(focusableElements).filter(element => {
      // Check if the element has a valid tabindex value
      const tabIndex = element.getAttribute('tabindex');
      if (tabIndex !== null && parseInt(tabIndex, 10) >= 0) {
        return true;
      }
      // Check for other default unfocused elements
      return (
        (element.tagName === 'A' && element.hasAttribute('href')) ||
        (element.tagName === 'BUTTON' && !element.disabled) ||
        (element.tagName === 'INPUT' && element.type !== 'hidden' && !element.disabled) ||
        (element.tagName === 'SELECT' && !element.disabled) ||
        (element.tagName === 'TEXTAREA' && !element.disabled)
      );
    });
  
    return filteredElements;
  }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
 
// console.log(capitalizeFirstLetter("hello world")); // 输出: Hello world


export {
    encrypt,
    rolesKey,
    forbiddenCodeArr,
    forbiddenCodeArr_set,
    forbiddenConnect,
    forbiddenConnect_set,
    codeForbiddenConnect,
    codeForbiddenConnect_set,
    forbiddenCodeObj,
    forbiddenCodeObj_set,
    selectedCodeArr,
    userLanguage,
    monitorTableColumns,
    monitorTableOperaBtns,
    codeTypeEnum,
    tranKey,
    isValidPassword,
    isValidUsername,
    regexPatternsObj,
    regexPatterns,
    textAreaPatterns,
    noSymbolRegexPatterns,
    generateId,
    getEncryptKey,
    getKey,
    uuid,
    getFocusableElements,
    capitalizeFirstLetter
};
